import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invalid",
  "use": "icon-invalid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-invalid\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C229.1 0 0 229.1 0 512s229.1 512 512 512 512-229.3 512-512S794.9 0 512 0zM264.6 466.5h495.1c20.4 0 37 16.6 37 37v11.4c0 20.4-16.6 37-37 37H264.6c-20.4 0-37-16.6-37-37v-11.4c0-20.5 16.6-37 37-37z\" p-id=\"21203\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol